<template>
  <div class="ContainDiv">
    <h3>学员培训考核档案卡</h3>
    <p class="p_title">{{ "培训班次：" + printContent.PeriodInfoName }}</p>
    <table class="data_tbl" cellspacing="0">
      <thead>
        <tr>
          <th style="width: 12%"></th>
          <th style="width: 13%"></th>
          <th style="width: 12%"></th>
          <th style="width: 13%"></th>
          <th style="width: 18%"></th>
          <th style="width: 17%"></th>
          <th style="width: 15%"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>序号</td>
          <td>{{ printContent.CheckOrder }}</td>
          <td>姓名</td>
          <td>{{ printContent.Name }}</td>
          <td>性别</td>
          <td>{{ printContent.Sex }}</td>
          <td rowspan="4">
            <img :src="printContent.PhotoUrl" style="width: 95%" alt="照片" />
          </td>
        </tr>
        <tr>
          <td>身份证号</td>
          <td colspan="2">{{ printContent.IDCard }}</td>
          <td>出生年月</td>
          <td colspan="2">{{ printContent.BornDate }}</td>
        </tr>
        <tr>
          <td>工作单位</td>
          <td colspan="3">{{ printContent.WorkSite }}</td>
          <td>企业性质</td>
          <td></td>
        </tr>
        <tr>
          <td>通讯地址</td>
          <td colspan="3">{{ printContent.PostalAddress }}</td>
          <td>邮政编码</td>
          <td></td>
        </tr>
        <tr>
          <td>文化程度</td>
          <td>{{ printContent.EduLevel }}</td>
          <td>职务</td>
          <td colspan="2">{{ printContent.WorkTypeName }}</td>
          <td>工作年限</td>
          <td>{{ printContent.WorkYear == 0 ? "" : printContent.WorkYear }}</td>
        </tr>
        <tr>
          <td>培训类别</td>
          <td colspan="2">{{ printContent.MenTypeName }}</td>
          <td>培训类型</td>
          <td colspan="3">{{ printContent.PeriodClass }}</td>
        </tr>
        <tr>
          <td>入学时间</td>
          <td>{{ printContent.TrainBegDateString }}</td>
          <td>结业时间</td>
          <td>{{ printContent.TrainEndDateString }}</td>
          <td>联系电话</td>
          <td colspan="2">{{ printContent.MobilePhone }}</td>
        </tr>
        <tr>
          <td>出勤天数</td>
          <td>{{ printContent.AttendanceDays }}</td>
          <td>缺课天数</td>
          <td>{{ printContent.AbsenceDays }}</td>
          <td>请假天数</td>
          <td colspan="2">{{ printContent.LeaveDays }}</td>
        </tr>
        <tr>
          <td>学习内容</td>
          <td
            colspan="6"
            style="text-align: left"
            v-html="printContent.StudyContent"
          ></td>
        </tr>
        <tr>
          <td rowspan="2">考试成绩</td>
          <td colspan="2">理论考核成绩</td>
          <td colspan="2">实操考核成绩</td>
          <td>考核结果</td>
          <td>发证时间</td>
        </tr>
        <tr>
          <td colspan="2">{{ printContent.ExamScoreString }}</td>
          <td colspan="2">{{ printContent.CtrlScoreString }}</td>
          <td>{{ printContent.ExamResultString }}</td>
          <td>{{ printContent.SendBookDateString }}</td>
        </tr>
        <tr>
          <td>鉴定评语</td>
          <td colspan="6">
            <p class="content_line1">{{ "培训考核" + printContent.ExamResultString }}</p>
            <p class="content_line2">
              班主任签字：
              <img
                v-if="printContent.SignUrl"
                :src="printContent.SignUrl"
                style="width: 180px"
                alt="班主任签字"
              />
            </p>
          </td>
        </tr>
        <tr>
          <td>培训单位意见</td>
          <td colspan="6">
            <p class="content_line1">同意</p>
            <p class="content_line2">（公章）</p>
            <p class="content_line3">{{ printContent.TrainEndDateString }}</p>
            <p
              v-if="printContent.WorkTypeName && printContent.WorkTypeName.length > 16"
              class="seal_image"
              :style="'top:' + (573 + printContent.SubjectCount * 21.6) + 'px'"
            >
              <img
                v-if="printContent.SealImage"
                :src="printContent.SealImage"
                alt="公章"
              />
            </p>
            <p
              v-else
              class="seal_image"
              :style="'top:' + (553 + printContent.SubjectCount * 21.6) + 'px'"
            >
              <img
                v-if="printContent.SealImage"
                :src="printContent.SealImage"
                alt="公章"
              />
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "PrintTrainDoc",
  data() {
    return {
      printContent: {},
    };
  },
  methods: {
    BackToIndex() {
      this.$router.push("/");
    },
  },
  activated() {
    let cacheData = localStorage.getItem("printTrainDocCacheData");
    if (!cacheData) {
      this.$router.push("/");
      return;
    }
    this.printContent = JSON.parse(cacheData);
    //console.log(this.printContent);
    window.print();
    //自动关闭窗口页面
    setTimeout(() => {
      window.close();
    }, 300);
  },
  created() {},
};
</script>
<style scoped>
h3 {
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

p {
  margin: 0 0 10px;
}

.ContainDiv {
  font-size: 12px;
  line-height: 1.42857143;
  font-family: sans-serif;
  -webkit-text-size-adjust: 100%;
  width: 100%;
  text-align: center;
}

.p_title {
  text-align: left;
  margin-left: 1%;
  margin-top: 40px;
}

.data_tbl {
  margin: 0 1% 0 1%;
  border-collapse: collapse;
  width: 98%;
  border-top: 1px solid #666;
  border-left: 1px solid #666;
}

.data_tbl td {
  border-bottom: 1px solid #666;
  border-right: 1px solid #666;
  height: 22px;
  line-height: 22px;
  word-break: break-all;
  padding: 2px;
  font-size: 10px;
  width: auto;
  text-align: center;
}

.content_line1 {
  margin-top: 10px;
  font-size: 18px;
}

.content_line2 {
  text-align: left;
  margin-left: 76%;
}

.content_line3 {
  text-align: left;
  margin-left: 75%;
}

.seal_image {
  position: absolute;
  left: 530px;
}

.seal_image img {
  width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/views/PrintTrainDoc.vue